import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const ActivityHistory = () => {
    const navigate = useNavigate();
    const [activities, setActivities] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [isDesktop, setIsDesktop] = useState(true);

    const [expandedLogs, setExpandedLogs] = useState({});

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth > 992);
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const fetchHistory = async () => {
            try {
                const userString = localStorage.getItem('user');
                let userId = null;

                if (userString) {
                    const userData = JSON.parse(userString);
                    userId = userData.Id;
                }

                if (!userId) {
                    console.error("Không tìm thấy thông tin người dùng đăng nhập!");
                    setIsLoading(false);
                    return;
                }

                const apiUrl = `${process.env.REACT_APP_API_BASE_URL}/activitylog?userId=${userId}`;

                const response = await fetch(apiUrl, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    }
                });

                if (response.ok) {
                    const data = await response.json();
                    setActivities(data);
                } else {
                    console.error("Lỗi từ Backend khi lấy lịch sử");
                }
            } catch (error) {
                console.error("Không thể kết nối tới server Backend:", error);
            } finally {
                setIsLoading(false);
            }
        };

        fetchHistory();
    }, []);

    const toggleExpand = (logId) => {
        setExpandedLogs(prev => ({
            ...prev,
            [logId]: !prev[logId]
        }));
    };

    const renderDiff = (oldValues, newValues) => {
        try {
            const oldObj = oldValues ? JSON.parse(oldValues) : {};
            const newObj = newValues ? JSON.parse(newValues) : {};

            const allKeys = Array.from(new Set([...Object.keys(oldObj), ...Object.keys(newObj)]));
            const changes = [];

            allKeys.forEach(key => {
                if (key === 'UpdatedDate' || key === 'CreatedAt' || key === 'Id') return;

                const oldVal = oldObj[key];
                const newVal = newObj[key];

                if (String(oldVal) !== String(newVal)) {
                    changes.push({
                        key,
                        old: oldVal === null || oldVal === undefined || oldVal === '' ? 'Trống' : String(oldVal),
                        new: newVal === null || newVal === undefined || newVal === '' ? 'Trống' : String(newVal)
                    });
                }
            });

            if (changes.length === 0) {
                return <div style={{ color: '#888', fontStyle: 'italic', padding: '10px', fontSize: '13px' }}>Chỉ thay đổi thời gian cập nhật hoặc trạng thái (Không có thay đổi dữ liệu thực thể).</div>;
            }

            return (
                <div style={{ marginTop: '12px', backgroundColor: '#fff', borderRadius: '6px', border: '1px solid #e2e8f0', overflow: 'hidden' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                        <thead style={{ backgroundColor: '#f8fafc' }}>
                            <tr>
                                <th style={{ padding: '8px 12px', textAlign: 'left', borderBottom: '1px solid #e2e8f0', color: '#475569', width: '25%' }}>Thuộc tính</th>
                                <th style={{ padding: '8px 12px', textAlign: 'left', borderBottom: '1px solid #e2e8f0', color: '#e74c3c', width: '37.5%' }}>Dữ liệu cũ (Bị xóa/Sửa)</th>
                                <th style={{ padding: '8px 12px', textAlign: 'left', borderBottom: '1px solid #e2e8f0', color: '#27ae60', width: '37.5%' }}>Dữ liệu mới (Cập nhật)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {changes.map(change => (
                                <tr key={change.key}>
                                    <td style={{ padding: '8px 12px', borderBottom: '1px solid #f1f5f9', fontWeight: '600', color: '#334155' }}>{change.key}</td>
                                    <td style={{ padding: '8px 12px', borderBottom: '1px solid #f1f5f9', color: '#e74c3c', wordBreak: 'break-word', textDecoration: 'line-through' }}>{change.old}</td>
                                    <td style={{ padding: '8px 12px', borderBottom: '1px solid #f1f5f9', color: '#27ae60', wordBreak: 'break-word', fontWeight: '500' }}>{change.new}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        } catch (err) {
            return <div style={{ color: '#e74c3c', fontSize: '13px', marginTop: '5px' }}>Dữ liệu lưu vết phức tạp, không thể hiển thị đối chiếu trực tiếp.</div>;
        }
    };

    if (isLoading) {
        return <div style={{ textAlign: 'center', padding: '50px' }}><i className="fa-solid fa-circle-notch fa-spin"></i> Đang tải lịch sử</div>;
    }

    return (
        <div style={{ backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', padding: isDesktop ? '20px' : '15px 10px' }}>

            <div style={isDesktop
                ? { marginBottom: '30px', borderBottom: '1px solid #eee', paddingBottom: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }
                : { marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '15px', display: 'flex', flexDirection: 'column', gap: '15px', alignItems: 'flex-start' }
            }>
                <div>
                    <h2 style={{ margin: 0, color: '#2c3e50', fontSize: '20px', textTransform: 'uppercase' }}>Lịch sử hoạt động</h2>
                </div>

                <button
                    onClick={() => navigate(-1)}
                    style={{
                        padding: '8px 15px',
                        backgroundColor: '#f8f9fa',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        cursor: 'pointer',
                        color: '#333',
                        width: isDesktop ? 'auto' : '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}
                >
                    <i className="fa-solid fa-arrow-left" style={{ marginRight: '8px' }}></i>
                    Quay lại hồ sơ
                </button>
            </div>

            <div style={{ padding: isDesktop ? '20px' : '10px 5px' }}>
                {activities.length === 0 ? (
                    <div style={{ color: '#888', fontStyle: 'italic', textAlign: 'center' }}>Chưa có hoạt động nào được ghi nhận</div>
                ) : (
                    <div style={{ position: 'relative', paddingLeft: '30px' }}>

                        <div style={{ position: 'absolute', left: '14px', top: '10px', bottom: '0', width: '2px', backgroundColor: '#e0e0e0' }}></div>

                        {activities.map((item, index) => {
                            let dotColor = '#95a5a6';
                            const contentStr = item.content ? item.content.toLowerCase() : '';

                            if (contentStr.includes('đã gửi duyệt')) { dotColor = '#ffb948'; }
                            else if (contentStr.includes('đã duyệt')) { dotColor = '#1e8449'; }
                            else if (contentStr.includes('yêu cầu chỉnh sửa')) { dotColor = '#9b59b6'; }
                            else if (contentStr.includes('từ chối')) { dotColor = '#A52A2A'; }
                            else if (contentStr.includes('lưu nháp') || contentStr.includes('hủy duyệt')) { dotColor = '#7f8c8d'; }
                            else if (contentStr.includes('xóa') || contentStr.includes('hủy')) { dotColor = '#e74c3c'; }
                            else if (contentStr.includes('thêm mới') || contentStr.includes('tạo mới') || contentStr.includes('đăng ký')) { dotColor = '#2ecc71'; }
                            else if (contentStr.includes('cập nhật') || contentStr.includes('sửa')) { dotColor = '#3498db'; }

                            const hasDetails = (item.oldValues && item.oldValues.length > 5) || (item.newValues && item.newValues.length > 5);
                            const isExpanded = !!expandedLogs[item.id || index];

                            return (
                                <div key={item.id || index} style={{ position: 'relative', marginBottom: '25px' }}>

                                    <div style={{
                                        position: 'absolute', left: '-31px', top: '4px', width: '12px', height: '12px',
                                        borderRadius: '50%', backgroundColor: dotColor, border: '3px solid #fff',
                                        boxShadow: '0 0 0 1px #e0e0e0', zIndex: 1
                                    }}></div>

                                    <div style={{ backgroundColor: hasDetails ? '#f8fafc' : 'transparent', padding: hasDetails ? '12px' : '0', borderRadius: '8px', border: hasDetails ? '1px solid #e2e8f0' : 'none' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                                            <div style={{ fontSize: '13px', color: '#888' }}>
                                                {item.time}
                                            </div>
                                            {item.ipAddress && (
                                                <div style={{ fontSize: '11px', color: '#94a3b8', backgroundColor: '#e2e8f0', padding: '2px 8px', borderRadius: '10px' }}>
                                                    IP: {item.ipAddress}
                                                </div>
                                            )}
                                        </div>

                                        <div style={{ fontSize: '14px', color: '#333', lineHeight: '1.5', wordBreak: 'break-word', fontWeight: hasDetails ? '500' : 'normal' }}>
                                            {item.content}
                                        </div>

                                        {hasDetails && (
                                            <div style={{ marginTop: '8px' }}>
                                                <button
                                                    onClick={() => toggleExpand(item.id || index)}
                                                    style={{ background: 'none', border: 'none', color: '#3498db', fontSize: '13px', padding: 0, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px' }}
                                                >
                                                    {isExpanded ? <><i className="fa-solid fa-chevron-up"></i> Thu gọn</> : <><i className="fa-solid fa-code-compare"></i> Xem chi tiết thay đổi</>}
                                                </button>

                                                {isExpanded && renderDiff(item.oldValues, item.newValues)}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};

export default ActivityHistory;